<template>
    <div class="PinAnalysisComponent DataTables">
        <p>{{ lang.infotext_1 }}:</p>
        <!-- numbers.length == symbolItems[symbolListSelected].length && numbers.length == symbolHDLItems[symbolHDLListSelected].length -->
            
            <b-badge v-if="isReady" :variant="checkPinCountMatching() ? 'success' : 'warning'">
                {{ lang.label_PinCountMatching }}
            </b-badge>
            <b-badge v-if="isReady" :variant="checkPinNumberMatching(pinNumberMatching) ? 'success' : 'warning'">
                {{ lang.label_PinNumberMatching }}
            </b-badge>
            <br><br>
  
        
        <br><br>
         
        <p>{{ lang.infotext_2 }}: </p>

        <b-row>
            <b-col cols="4">
                <b-row>
                    <b-col cols="7">
                        <div id="symbolSVGPlace"></div>
                    </b-col>
                    <b-col cols="5">
                        <span v-if="symbols.length > 0">
                            <b-form-select 
                                id="initial-sort-select" 
                                v-model="symbolListSelected" 
                                :options="symbolListOptions"
                                size="sm"
                            ></b-form-select>
                        </span>
                    </b-col>
                    
                </b-row>
            </b-col>
            <b-col cols="4">
                <span v-if="appConf.status.isHDL">
                    <b-row>
                    
                        <b-col cols="7">
                            
                            <div id="symbolHDLSVGPlace"></div>
                        </b-col>
                        <b-col cols="5">
                            <span v-if="hdlsymbols.length > 0">
                                <b-form-select 
                                    id="initial-sort-select" 
                                    v-model="symbolHDLListSelected" 
                                    :options="symbolHDLListOptions"
                                    size="sm"
                                ></b-form-select>
                                <br>
                                {{ lang.label_Primitives }}:
                                <br>
                                <b-form-select 
                                    id="initial-sort-select" 
                                    v-model="symbolHDLPrimitiveListSelected" 
                                    :options="symbolHDLPrimitiveListOptions"
                                    size="sm"
                                ></b-form-select>
                            </span>
                        </b-col>
                    
                    </b-row>
                </span>
            </b-col>
            <b-col cols="4">
                <b-row>
                        <b-col cols="7">
                            
                            <div id="footprintSVGPlace"></div>
                        </b-col>
                        <b-col cols="5">
                            <span v-if="footprints.length > 0">
                                {{ footprintListSelected }}
                            </span>
                        </b-col>
                    
                    </b-row>
            </b-col>
        </b-row>
        <br><br>
        

        <div v-show="isData" :id="id"></div>
        

        <LoaderComponent v-if="!isData"></LoaderComponent>

    </div>
</template>
<script>


import LoaderComponent from "@/components/shared/LoaderComponent";
import { mapGetters } from 'vuex'
import $ from 'jquery';
import dt from 'datatables.net-bs4';
import * as Tools from '@/Tools/Tools'
import LibraryTypes from '@/constants/LibraryTypes'

export default {
    name: 'PinAnalysisComponent',
    props: {
        lang: Object,
        parent: String

    },
    components: {
        LoaderComponent

    },
    data() {
        return {
            name: 'PinAnalysisComponent',
            mainTable: "",
            id: "PinAnalysisComponent" + this._uid,
            columns: [],
            colsAssign: [],
            elements: [],
            isData: false,
            elementId: "",
            isReady: false,

            items: [],
            numbers: [],

            currentPackage: 0,
            currentHDLPackage: 0,
            
            pinNumberMatching: true,
            pinCountMatching: true,


            symbols: [],
            symbolItems: [],
            symbolListSelected: [],
            symbolListOptions: [],
            symbolImage: {},
            symbolRevisionId: [],
            packages: [],

            hdlsymbols: [],
            symbolHDLItems: [],
            symbolHDLListSelected: [],
            symbolHDLListOptions: [],
            symbolHDLPrimitiveListSelected: [],
            symbolHDLPrimitiveListOptions: [],
            symbolHDLImage: {},
            symbolHDLRevisionId: [],
            packagesHDL: [],
            
            symbolHDLMatrixOptions: [],

            footprints: [],
            footprintItems: [],
            footprintListSelected: [],
            footprintImage: {},
            footprintRevisionId: [],
        }
    },
    computed: {
        ...mapGetters([
            'selectedRevisionRow',
            'appConf'
        ]), 
        variant() {
            if (this.$store.getters.s_skinVariant == "dark") {
                return "light";
            } else {
                return "dark";
            }

        },
        revisionId() {

            if (this.parent == "bom") {
                return this.$store.getters.selectedPartBomRow.revisionId;
            }
            if (this.$route.path == "/PartManager/PartTable") {
                if (this.$store.getters.selectedRows[0] != undefined) {
                    if (this.$store.getters.sectionPrefix == "pm") {

                        this.elementId = this.$store.getters.selectedRows[0].col___revisionId.partId;
                    }
                    if (this.$store.getters.sectionPrefix == "lm") {
                        this.elementId = this.$store.getters.selectedRows[0].col___revisionId.libraryId;
                    }
                    return this.$store.getters.selectedRows[0].col___revisionId.revisionId;
                }
            }
            if (this.$route.path == "/PartManager/PartDetails") {
                if (this.selectedRevisionRow[0] != undefined) {

                    this.elementId = this.$store.getters.selectedRows[0].col___revisionId.libraryId;
                    return this.selectedRevisionRow[0].revisionId;
                }

            }
            return ""




        },


        reloadedAfterActionComplex() {
            return this.$store.getters.reloadedAfterActionComplex;
        },
        
        

    },
    created() {

        this.createTables();


    },
    watch: {
        revisionId: {
            handler: function () {

                this.createTables();
            },
            deep: true


        },


        reloadedAfterActionComplex: {
            handler: function (newValue) {

                for (let el in newValue) {

                    if (newValue[el].name == this.name) {
                        if (newValue[el].status == true) {

                            this.createTables();

                            newValue[el].status = false;

                            this.$store.dispatch("reloadAfterActionComplex", newValue[el]);
                        }
                    }
                }
            },
            deep: true

        },
        currentPackage: function () {



            let barValue = document.getElementById("pinbarValue");
            if (barValue != null) {
                let index = this.currentPackage + 1;
                barValue.value = this.packages[this.currentPackage] + " (" + index + "/" + this.packages.length + ")";

                let leftbar = document.getElementById("pinleftbar_" + this.id);
                let rightbar = document.getElementById("pinrightbar_" + this.id);

                if (this.currentPackage == 0) {
                    leftbar.disabled = true;
                } else {
                    leftbar.disabled = false;
                }

                if (this.currentPackage == this.packages.length - 1) {
                    rightbar.disabled = true;
                } else {
                    rightbar.disabled = false;
                }



                for (var i = 0, le = this.packages.length; i < le; i++) {
                    var layer = "PACKAGES_" + this.packages[i];

                    if (i == this.currentPackage) {
                        if (this.place.getElementsByClassName(layer)[0] != undefined) {
                            this.place.getElementsByClassName(layer)[0].style["visibility"] = "visible";
                        }


                    } else {
                        if (this.place.getElementsByClassName(layer)[0] != undefined) {
                            this.place.getElementsByClassName(layer)[0].style["visibility"] = "hidden";
                        }
                    }


                }
            }

            

        },
        currentHDLPackage: function () {



            let barValue = document.getElementById("pinbarHDLValue");
            
            if (barValue != null) {
                let index = this.currentHDLPackage + 1;
                barValue.value = this.packagesHDL[this.currentHDLPackage] + " (" + index + "/" + this.packagesHDL.length + ")";

                let leftbar = document.getElementById("pinleftbarHDL_" + this.id);
                let rightbar = document.getElementById("pinrightbarHDL_" + this.id);

                if (this.currentHDLPackage == 0) {
                    leftbar.disabled = true;
                } else {
                    leftbar.disabled = false;
                }

                if (this.currentHDLPackage == this.packagesHDL.length - 1) {
                    rightbar.disabled = true;
                } else {
                    rightbar.disabled = false;
                }



                for (var i = 0, le = this.packagesHDL.length; i < le; i++) {
                    var layer = "PACKAGES_" + this.packagesHDL[i];

                    if (i == this.currentHDLPackage) {
                        if (this.placeHDL.getElementsByClassName(layer)[0] != undefined) {
                            this.placeHDL.getElementsByClassName(layer)[0].style["visibility"] = "visible";
                        }


                    } else {
                        if (this.placeHDL.getElementsByClassName(layer)[0] != undefined) {
                            this.placeHDL.getElementsByClassName(layer)[0].style["visibility"] = "hidden";
                        }
                    }


                }
            }

            

        },

        symbolListSelected: function (newVal) {
            

            let obj = {
                revisionId: this.symbolRevisionId[newVal],
                name: newVal,
                libraryType: LibraryTypes.PART
            }

            this.getSVG(obj);
            
            
            this.checkNumbering();
        },
        symbolHDLListSelected: function (newVal) {
            
            

            if (this.symbolHDLMatrixOptions[newVal] != undefined ) {
                this.symbolHDLPrimitiveListSelected = this.symbolHDLMatrixOptions[newVal][0];
                this.symbolHDLPrimitiveListOptions = this.symbolHDLMatrixOptions[newVal];
                
                this.checkNumbering();
            }

            
            let obj = {
                revisionId: this.symbolHDLRevisionId[newVal],
                name: newVal,
                libraryType: LibraryTypes.HDLSYMBOL
            }

            this.getSVG(obj);
        },
        symbolHDLPrimitiveListSelected: function (newVal) {

            
            if (this.symbolHDLMatrixOptions[this.symbolHDLListSelected] != undefined && this.symbolHDLListSelected.length > 0) {
                this.symbolHDLItems = this.symbolHDLMatrixOptions[this.symbolHDLListSelected][newVal];
                
                this.checkNumbering();
            }

            
        }
    },
    
    methods: {
        getSVG(obj) {

            let vue = this;
          
            if (obj.revisionId == undefined) {
                return;
            }
            let id = "xxxyyyzzz";
             if (obj.libraryType == LibraryTypes.PART) {
                id = "pinsSymbol__" + obj.revisionId;
            }
            if (obj.libraryType == LibraryTypes.HDLSYMBOL) {
                id = "pinsHdlsymbol__" + obj.revisionId;
            }
            if (obj.libraryType == LibraryTypes.FOOTPRINT) {
                id = "pinsFootprint__" + obj.revisionId;
            }
            
            
            const objSvg = {
                type: obj.libraryType,
                name: obj.name,
                id: id,
                revisionId: obj.revisionId
            }

            this.$store.dispatch(this.$store.getters.sectionPrefix + "_getSvg", objSvg)
                .then((result) => {

                    if (result != null) {


                        let id = result.id;
                        vue.loadSVG(result, id, obj);


                    }

                })
                    
            
        },
        async loadSVG(blob, id, obj) {

            let bar = "";
            let barid = "";
            let pinOption = "";

            

            
            
            if (obj.libraryType == LibraryTypes.PART) {
                pinOption = "<input class=\"checkboxPinOptionAnalysis\" type=\"checkbox\" value=\"\"> " + this.lang.label_pinSwitch;
                barid = "pinsbar_symbol__" + obj.revisionId + "_" + this.id;
                bar = "<div id=\"" + barid + "\" class=\"bar-symbol\"></div>";
            }
            if (obj.libraryType == LibraryTypes.HDLSYMBOL) {
                
                barid = "pinsbar_hdlsymbol__" + obj.revisionId + "_" + this.id;
                bar = "<div id=\"" + barid + "\" class=\"bar-symbol\"></div>";
            }

            

            let image = "<div id=\"" + id + "\" data-revisionid=\"" + obj.revisionId + "\" data-name=\"" + obj.name + "\" data-type=\"" + obj.libraryType + "\" class=\"image-zoom image-footprint\"></div>" + bar + pinOption;
            let placeId = "";
            if (obj.libraryType == LibraryTypes.PART) {
                placeId = "symbolSVGPlace";
                
            }
            if (obj.libraryType == LibraryTypes.HDLSYMBOL) {
                placeId = "symbolHDLSVGPlace";
                
            }
            if (obj.libraryType == LibraryTypes.FOOTPRINT) {
                placeId = "footprintSVGPlace";
            }
            let place = document.getElementById(placeId);
            
            if (place != null) {
                place.innerHTML = image;
            }


            let svgData = await new Response(blob).text();

            place = document.getElementById(id);
            if (place != null) {
                place.innerHTML = "";

                var parser = new DOMParser();
                var doc = parser.parseFromString(svgData, "image/svg+xml");
                doc.documentElement.setAttribute("width", 200);
                doc.documentElement.setAttribute("height", 200);

                place.appendChild(doc.documentElement);

                if (place.dataset.type == LibraryTypes.PART || place.dataset.type == LibraryTypes.SYMBOL) {

                    this.buildSymbolViewer(doc, place, obj.revisionId);
                    this.pinsToggle();
                }
                if (place.dataset.type == LibraryTypes.HDLSYMBOL) {

                    this.buildHDLSymbolViewer(doc, place, obj.revisionId);
                }



            }

        },
        buildSymbolViewer(doc, place, revisionId) {

            let vue = this;

            let svg = doc.firstChild

            this.place = place;
            let barid = "pinsbar_symbol__" + revisionId + "_" + this.id;


            let symbolbar = document.getElementById(barid);

            if (symbolbar != null) {
                symbolbar.innerHTML = "";

                let group = place.getElementsByTagName(`g`);

                this.packages = [];
                this.currentPackage = 0;
                for (let i = 0, lei = group.length; i < lei; i++) {

                    let temp = group[i].className.baseVal.split("_");
                    if (temp[0] == "PACKAGES") {
                        this.packages.push(temp[1])
                    }
                }


                if (this.packages.length > 1) {

                    this.symbolSvg = svg;


                    let index = this.currentPackage + 1;
                    let valueBar = this.packages[this.currentPackage] + " (" + index + "/" + this.packages.length + ")";

                    const bar = `<div role="group" class="input-group  input-group-sm">
                            <div class="input-group-prepend">
                            <button disabled="disabled" id="pinleftbar_`+ this.id + `" type="button" class="btn btn-sm btn-` + this.variant + ` btn-bar">&lt;</button>
                            </div> 
                            <input type="text" disabled="disabled" class="form-control form-control-sm input-viewer" id="pinbarValue" value="`+ valueBar + `" style="text-align:center;"> 
                            <div class="input-group-append">
                            <button id="pinrightbar_`+ this.id + `" type="button" class="btn btn-sm btn-` + this.variant + ` btn-bar">&gt;</button>
                            </div>
                            </div>`;

                    symbolbar.innerHTML = bar;

                    let leftbar = document.getElementById("pinleftbar_" + this.id);
                    leftbar.addEventListener("click", function (e) {

                        if (vue.currentPackage == 0) {

                        } else {

                            vue.currentPackage--;
                        }

                    })
                    let rightbar = document.getElementById("pinrightbar_" + this.id);
                    rightbar.addEventListener("click", function (e) {

                        if (vue.currentPackage == vue.packages.length) {

                        } else {

                            vue.currentPackage++;
                        }
                    })




                } else {
                    this.symbolSvg = {};
                }
            }






        },
        buildHDLSymbolViewer(doc, place, revisionId) {

            let vue = this;

            let svg = doc.firstChild

            this.placeHDL = place;
            let barid = "pinsbar_hdlsymbol__" + revisionId + "_" + this.id;


            let symbolbar = document.getElementById(barid);
           

            if (symbolbar != null) {
                symbolbar.innerHTML = "";

                let group = place.getElementsByTagName(`g`);

                this.packagesHDL = [];
                this.currentHDLPackage = 0;
                for (let i = 0, lei = group.length; i < lei; i++) {

                    let temp = group[i].className.baseVal.split("_");
                    if (temp[0] == "PACKAGES") {
                        this.packagesHDL.push(temp[1])
                    }
                }


                if (this.packagesHDL.length > 1) {

                    this.symbolSvg = svg;





                    let index = this.currentHDLPackage + 1;
                    let valueBar = this.packagesHDL[this.currentHDLPackage] + " (" + index + "/" + this.packagesHDL.length + ")";

                    const bar = `<div role="group" class="input-group  input-group-sm">
                            <div class="input-group-prepend">
                            <button disabled="disabled" id="pinleftbarHDL_`+ this.id + `" type="button" class="btn btn-sm btn-` + this.variant + `">&lt;</button>
                            </div> 
                            <input type="text" disabled="disabled" class="form-control form-control-sm input-viewer" id="pinbarHDLValue" value="`+ valueBar + `" style="text-align:center;"> 
                            <div class="input-group-append">
                            <button id="pinrightbarHDL_`+ this.id + `" type="button" class="btn btn-sm btn-` + this.variant + `">&gt;</button>
                            </div>
                            </div>`;

                    symbolbar.innerHTML = bar;

                    let leftbar = document.getElementById("pinleftbarHDL_" + this.id);
                    leftbar.addEventListener("click", function (e) {

                        if (vue.currentHDLPackage == 0) {

                        } else {

                            vue.currentHDLPackage--;
                        }

                    })
                    let rightbar = document.getElementById("pinrightbarHDL_" + this.id);
                    rightbar.addEventListener("click", function (e) {

                        if (vue.currentHDLPackage == vue.packagesHDL.length) {

                        } else {

                            vue.currentHDLPackage++;
                        }
                    })




                } else {
                    this.symbolSvg = {};
                }
            }




        },
        createTables() {
            this.isData = false;
            let vue = this;

            let prefix = this.$store.getters.sectionPrefix;
            if (this.parent == "bom") {
                prefix = "lm";
            }

            let obj = {

                partRevisionId: this.revisionId


            }


            this.$store.dispatch(prefix + "_getPins", obj)
                .then((result) => {
                    console.log(result)
                    if (result.status == "OK") {


                        vue.isData = true;

                        

                        vue.symbols = result.data[0].symbols;
                        vue.hdlsymbols = this.converseFromMultiPins(result.data[0].hdlsymbols);
                        vue.footprints = result.data[0].footprints;


                        vue.buildColumns();

                    } else {
                        vue.isData = false;
                    }


                })
        },
        buildColumns() {

            if (this.appConf.status.isHDL == false) {
                this.columns = [
                    // {
                    //     name: "Id",
                    //     alignInColumn: "left",
                    //     type: "text"
                    // },
                    {
                        name: this.lang.table_header_Number,
                        alignInColumn: "left",
                        type: "text"
                    },
                    {
                        name: this.lang.table_header_Name,
                        alignInColumn: "left",
                        type: "text"
                    },
                    {
                        name: this.lang.table_header_Type,
                        alignInColumn: "left",
                        type: "text"
                    },
                    {
                        name: this.lang.table_header_Number,
                        alignInColumn: "left",
                        type: "text"
                    },
                    {
                        name: this.lang.table_header_Padstack,
                        alignInColumn: "left",
                        type: "taxt"
                    },
                    {
                        name: this.lang.table_header_Type,
                        alignInColumn: "left",
                        type: "text"
                    },


                ]

                this.colsAssign = [

                    //{ "data": "number" },
                    { "data": "pinNumber_symbol" },
                    { "data": "pinName_symbol" },
                    { "data": "type_symbol" },
                    

                    { "data": "pinNumber_footprint" },
                    { "data": "padstack_footprint" },
                    { "data": "type_footprint" },


                ]
            } else {
                this.columns = [
                    // {
                    //     name: "Id",
                    //     alignInColumn: "left",
                    //     type: "text"
                    // },
                    {
                        name: this.lang.table_header_Number,
                        alignInColumn: "left",
                        type: "text"
                    },
                    {
                        name: this.lang.table_header_Name,
                        alignInColumn: "left",
                        type: "text"
                    },
                    {
                        name: this.lang.table_header_Type,
                        alignInColumn: "left",
                        type: "text"
                    },
                    {
                        name: this.lang.table_header_Number,
                        alignInColumn: "left",
                        type: "text"
                    },
                    {
                        name: this.lang.table_header_Name,
                        alignInColumn: "left",
                        type: "text"
                    },
                    {
                        name: this.lang.table_header_Type,
                        alignInColumn: "left",
                        type: "text"
                    },
                    {
                        name: this.lang.table_header_Number,
                        alignInColumn: "left",
                        type: "text"
                    },
                    {
                        name: this.lang.table_header_Padstack,
                        alignInColumn: "left",
                        type: "taxt"
                    },
                    {
                        name: this.lang.table_header_Type,
                        alignInColumn: "left",
                        type: "text"
                    },


                ]

                this.colsAssign = [

                    //{ "data": "number" },
                    { "data": "pinNumber_symbol" },
                    { "data": "pinName_symbol" },
                    { "data": "type_symbol" },


                    { "data": "pinNumber_hdlsymbol" },
                    { "data": "pinName_hdlsymbol" },
                    { "data": "type_hdlsymbol" },

                    { "data": "pinNumber_footprint" },
                    { "data": "padstack_footprint" },
                    { "data": "type_footprint" },


                ]
            }

        
            this.getBasic();

        },
        getBasic() {

            if (this.symbols[0] != undefined) {
                this.symbolListSelected = this.symbols[0].name;
            }

            if (this.hdlsymbols[0] != undefined ) {
                this.symbolHDLListSelected = this.hdlsymbols[0].name;
            }
            
            if (this.hdlsymbols[0] != undefined && this.hdlsymbols[0].primitives.length > 0) {

                this.symbolHDLPrimitiveListSelected = this.hdlsymbols[0].primitives[0].name;
            }
            
            if (this.footprints[0] != undefined ) {
                this.footprintListSelected = this.footprints[0].name;
                this.footprintRevisionId[this.footprints[0].name] = this.footprints[0].revisionId;

                let obj = {
                    revisionId: this.footprintRevisionId[this.footprintListSelected],
                    name: this.footprintListSelected,
                    libraryType: LibraryTypes.FOOTPRINT
                }

                this.getSVG(obj);
            }
            
            this.checkNumbering();
        },
        checkNumbering() {

            this.numbers = [];
            this.items = [];

            if (this.symbols.length > 0) {
                for (let i = 0, lei = this.symbols.length; i < lei; i++) {
                    
                    if (this.symbols[i].name == this.symbolListSelected) {
                        for (let j = 0, lej = this.symbols[i].pins.length; j < lej; j++) {

                            if (!this.numbers.includes(this.symbols[i].pins[j].pinNumber)) {

                                let obj = {
                                    number: this.symbols[i].pins[j].pinNumber,
                                    pinNumber_symbol: "",
                                    pinName_symbol: "",
                                    type_symbol: "",

                                    pinNumber_hdlsymbol: "",
                                    pinName_hdlsymbol: "",
                                    type_hdlsymbol: "",

                                    pinNumber_footprint: "",
                                    padstack_footprint: "",
                                    type_footprint: ""
                                }
                                
                                this.items.push(obj);
                                this.numbers.push(this.symbols[i].pins[j].pinNumber);


                            }

                        }
                    }

                }

            }
            if (this.appConf.status.isHDL == true) {

                if (this.hdlsymbols.length > 0) {
                    for (let i = 0, lei = this.hdlsymbols.length; i < lei; i++) {

                        for (let j = 0, lej = this.hdlsymbols[i].primitives.length; j < lej; j++) {
                            
                            if (this.symbolHDLPrimitiveListSelected == this.hdlsymbols[i].primitives[j].name) {
                                for (let k = 0, lek = this.hdlsymbols[i].primitives[j].pins.length; k < lek; k++) {

                                    if (!this.numbers.includes(this.hdlsymbols[i].primitives[j].pins[k].pinNumber)) {

                                        let obj = {
                                            number: this.hdlsymbols[i].primitives[j].pins[k].pinNumber,
                                            pinNumber_symbol: "",
                                            pinName_symbol: "",
                                            type_symbol: "",

                                            pinNumber_hdlsymbol: "",
                                            pinName_hdlsymbol: "",
                                            type_hdlsymbol: "",

                                            pinNumber_footprint: "",
                                            padstack_footprint: "",
                                            type_footprint: ""
                                        }
                                        
                                        this.items.push(obj);
                                        this.numbers.push(this.hdlsymbols[i].primitives[j].pins[k].pinNumber);
                                    }

                                }
                            }

                        }
                    }

                }
            }
           
            if (this.footprints.length > 0) {
                for (let i = 0, lei = this.footprints.length; i < lei; i++) {
                    
                    if (this.footprints[i].name == this.footprintListSelected) {
                        for (let j = 0, lej = this.footprints[i].pins.length; j < lej; j++) {

                            if (!this.numbers.includes(this.footprints[i].pins[j].pinNumber)) {

                                let obj = {
                                    number: this.footprints[i].pins[j].pinNumber,
                                    pinNumber_symbol: "",
                                    pinName_symbol: "",
                                    type_symbol: "",

                                    pinNumber_hdlsymbol: "",
                                    pinName_hdlsymbol: "",
                                    type_hdlsymbol: "",

                                    pinNumber_footprint: "",
                                    padstack_footprint: "",
                                    type_footprint: ""
                                }

                                
                                
                                
                                if (this.footprints[i].pins[j].type !== "mechanical") {
                                    
                                    this.items.push(obj);
                                    this.numbers.push(this.footprints[i].pins[j].pinNumber);
                                }
                            }

                        }
                    }
                    
                }

            }
            



            this.createPinsTables();
            
        },
        createPinsTables() {

            if (this.appConf.status.isHDL == true) {

            }


            

            //symbols
            this.symbolItems = [];
            this.symbolListOptions = [];
            if (this.symbols.length > 0) {
                for (let i = 0, lei = this.symbols.length; i < lei; i++) {

                    let arr = [];
                    this.symbolListOptions.push(this.symbols[i].name)

                    for (let j = 0, lej = this.symbols[i].pins.length; j < lej; j++) {

                        let obj = {
                            index: j,
                            pinNumber: this.symbols[i].pins[j].pinNumber,
                            pinName: this.symbols[i].pins[j].pinName,
                            type: this.symbols[i].pins[j].type,
                        }



                        arr.push(obj);

                    }

                    this.symbolItems[this.symbols[i].name] = arr;
                    this.symbolRevisionId[this.symbols[i].name] = this.symbols[i].revisionId;
                }
                //this.symbolListSelected = this.symbols[0].name;
            }

            
            

            //hdlsymbols
            this.symbolHDLItems = [];
            this.symbolHDLListOptions = [];
            this.symbolHDLMatrixOptions = [];
            //this.symbolHDLPrimitiveListSelected = [];
            //this.symbolHDLPrimitiveListOptions = [];

            if (this.hdlsymbols.length >= 0) {
                for (let i = 0, lei = this.hdlsymbols.length; i < lei; i++) {
                    this.symbolHDLListOptions.push(this.hdlsymbols[i].name)
                    this.symbolHDLMatrixOptions[this.hdlsymbols[i].name] = [];


                    for (let j = 0, lej = this.hdlsymbols[i].primitives.length; j < lej; j++) {
                        let arr = [];


                        
                        for (let k = 0, lek = this.hdlsymbols[i].primitives[j].pins.length; k < lek; k++) {

                            let obj = {
                                index: j,
                                pinNumber: this.hdlsymbols[i].primitives[j].pins[k].pinNumber,
                                pinName: this.hdlsymbols[i].primitives[j].pins[k].pinName,
                                type: this.hdlsymbols[i].primitives[j].pins[k].type,
                            }
                            arr.push(obj);
                        }
                        
            
                        this.symbolHDLMatrixOptions[this.hdlsymbols[i].name].push(this.hdlsymbols[i].primitives[j].name)
                        this.symbolHDLMatrixOptions[this.hdlsymbols[i].name][this.hdlsymbols[i].primitives[j].name] = arr;
                        
                    }
                    this.symbolHDLRevisionId[this.hdlsymbols[i].name] = this.hdlsymbols[i].revisionId;

                }
                
                
                if (this.symbolHDLListSelected.length > 0) {
                    if (this.symbolHDLMatrixOptions[this.symbolHDLListSelected][this.symbolHDLPrimitiveListSelected] !== undefined) {
                        this.symbolHDLItems = this.symbolHDLMatrixOptions[this.symbolHDLListSelected][this.symbolHDLPrimitiveListSelected];
                        
                    } else {
                        
                        this.symbolHDLItems = this.symbolHDLMatrixOptions[this.symbolHDLListSelected];
                    }

                }
            }
            

            //footprints
            this.footprintItems = [];
            this.footprintListOptions = [];
            if (this.footprints.length > 0) {
                for (let i = 0, lei = this.footprints.length; i < lei; i++) {
                    
                    this.footprintListOptions.push(this.footprints[i].name)
                    let arr = [];

                    for (let j = 0, lej = this.footprints[i].pins.length; j < lej; j++) {

                        let obj = {
                            index: j,
                            pinNumber: this.footprints[i].pins[j].pinNumber,
                            padstackName: this.footprints[i].pins[j].padstackName,
                            type: this.footprints[i].pins[j].type,
                        }
                        if (this.footprints[i].pins[j].type !== "mechanical") {
                            arr.push(obj);
                        }
                        

                    }
                    
                    this.footprintItems[this.footprints[i].name] = arr;
                    
                    
                    
                }
                
                


            }
            

            


            for (let k = 0, lek = this.numbers.length; k < lek; k++) {

                if (this.symbolItems[this.symbolListSelected] != undefined) {
                    for (let i = 0, lei = this.symbolItems[this.symbolListSelected].length; i < lei; i++) {

                        if (this.numbers[k] == this.symbolItems[this.symbolListSelected][i].pinNumber) {


                            this.items[k].pinNumber_symbol = this.symbolItems[this.symbolListSelected][i].pinNumber;
                            this.items[k].pinName_symbol = this.symbolItems[this.symbolListSelected][i].pinName;
                            this.items[k].type_symbol = this.symbolItems[this.symbolListSelected][i].type;


                        }

                    }
                }

                if (this.symbolHDLMatrixOptions[this.symbolHDLListSelected] != undefined) {
                    if (this.symbolHDLMatrixOptions[this.symbolHDLListSelected][this.symbolHDLPrimitiveListSelected] != undefined) {
                        for (let i = 0, lei = this.symbolHDLMatrixOptions[this.symbolHDLListSelected][this.symbolHDLPrimitiveListSelected].length; i < lei; i++) {


                            if (this.numbers[k] == this.symbolHDLMatrixOptions[this.symbolHDLListSelected][this.symbolHDLPrimitiveListSelected][i].pinNumber) {

                                this.items[k].pinNumber_hdlsymbol = this.symbolHDLMatrixOptions[this.symbolHDLListSelected][this.symbolHDLPrimitiveListSelected][i].pinNumber;
                                this.items[k].pinName_hdlsymbol = this.symbolHDLMatrixOptions[this.symbolHDLListSelected][this.symbolHDLPrimitiveListSelected][i].pinName;
                                this.items[k].type_hdlsymbol = this.symbolHDLMatrixOptions[this.symbolHDLListSelected][this.symbolHDLPrimitiveListSelected][i].type;

                            }
                        }
                    }
                }
                

                
                if (this.footprintItems[this.footprintListSelected] != undefined) {
                    for (let i = 0, lei = this.footprintItems[this.footprintListSelected].length; i < lei; i++) {

                        if (this.numbers[k] == this.footprintItems[this.footprintListSelected][i].pinNumber) {


                            this.items[k].pinNumber_footprint = this.footprintItems[this.footprintListSelected][i].pinNumber;
                            this.items[k].padstack_footprint = this.footprintItems[this.footprintListSelected][i].padstackName;
                            this.items[k].type_footprint = this.footprintItems[this.footprintListSelected][i].type;


                        }

                    }
                }
                
                
                

            }



            this.buildTable();
            

        },
        converseFromMultiPins(data) {


          
            if (data != undefined) {

                let trigs = [];

                for (let i = 0, lei = data.length; i < lei; i++) {
                    for (let j = 0, lej = data[i].primitives.length; j < lej; j++) {
                        for (let k = 0, lek = data[i].primitives[j].pins.length; k < lek; k++) {
                            
                            if (data[i].primitives[j].pins[k].pinNumber.indexOf(",") > -1) {
                                trigs[data[i].primitives[j].name] = true;
                            } 
                            
                        }
                        
                    }
                    
                }
                
                

                

                for (let i = 0, lei = data.length; i < lei; i++) {
                    for (let j = 0, lej = data[i].primitives.length; j < lej; j++) {
                        let newdata = [];
                        for (let k = 0, lek = data[i].primitives[j].pins.length; k < lek; k++) {

                            

                            if (trigs[data[i].primitives[j].name] == true) {
                                
                                let temp = data[i].primitives[j].pins[k].pinNumber.split(",");

                                for (let n = 0, len = temp.length; n < len; n++) {

                                    let obj = {
                                        index: newdata.length,
                                        pinName: data[i].primitives[j].pins[k].pinName,
                                        pinNumber: temp[n],
                                        type: data[i].primitives[j].pins[k].type
                                    }
                                    

                                    let trig2 = false;
                                    for (let m = 0, lem = newdata.length; m < lem; m++) {

                                        if (newdata[m].pinNumber == obj.pinNumber) {
                                            trig2 = true;

                                        } else {
                                            trig2 = false;

                                        }
                                    }

                                    if (trig2 == false) {

                                        newdata.push(obj);
                                    }
                                    
                                }

                                

                                
                            } 

                        }
                     
                        if (trigs[data[i].primitives[j].name] == true) {
                            data[i].primitives[j].pins = newdata;
                        }
                    }

                }
                

            }

            return data;
        },
        pinsToggle() {

            
            let checkboxPinOptionAnalysis = document.getElementsByClassName('checkboxPinOptionAnalysis');


            for (var i = 0; i < checkboxPinOptionAnalysis.length; i++) {
                checkboxPinOptionAnalysis[i].addEventListener('click', function () {

                    let svg = document.getElementById("symbolSVGPlace");
                    
                    const pinsNameslayers = svg.querySelectorAll('[class="PINS_NAMES"]')

                    const pinsNumberlayers = svg.querySelectorAll('[class="PINS_NUMBERS"]')

                    if (this.checked == true) {
                        for (let i = 0, lei = pinsNumberlayers.length; i < lei; i++) {
                            pinsNumberlayers[i].style.display = "none";
                        }
                        for (let i = 0, lei = pinsNameslayers.length; i < lei; i++) {
                            pinsNameslayers[i].style.display = "block";
                        }


                    } else {
                        for (let i = 0, lei = pinsNumberlayers.length; i < lei; i++) {
                            pinsNumberlayers[i].style.display = "block";
                        }
                        for (let i = 0, lei = pinsNameslayers.length; i < lei; i++) {
                            pinsNameslayers[i].style.display = "none";
                        }


                    }


                })
            }
        },
        checkPinNumberMatching(value) {

            
            if (this.numbers.length == 0) {
                value = false;
            }
            return value;
        },
        checkPinCountMatching() {
            let status = false;

            
            if (this.appConf.status.isHDL == true) {
                
                
                
                if (this.symbolItems[this.symbolListSelected] != undefined && this.symbolHDLItems != undefined && this.footprintItems[this.footprintListSelected] != undefined) {

                
                    
                    
                    if (this.symbolItems[this.symbolListSelected].length === this.symbolHDLItems.length && this.symbolHDLItems.length === this.footprintItems[this.footprintListSelected].length) {
                        
                        status = true;
                    }
                    
                }
                    
            } else {
                
                if (this.symbolItems[this.symbolListSelected] != undefined && this.footprintItems[this.footprintListSelected] != undefined) {

                    if (this.symbolItems[this.symbolListSelected].length === this.footprintItems[this.footprintListSelected].length) {
                        status = true;
                    }
                }
            }
            if (this.numbers.length == 0) {
                status = false;
            }
           

            // if (this.numbers.length == this.items.length) {
            //     status = true;
            // }


            return status;
        },
        buildTable() {
            this.isReady = true;
            
            var tableplace = document.getElementById(this.id);
            if (tableplace == null) {
                return;
            }

            while (tableplace.firstChild) {
                tableplace.removeChild(tableplace.firstChild);
            }

            var table = document.createElement("table");
            table.setAttribute("id", "t_" + this.id);
            table.setAttribute("style", "width:100%");
            table.setAttribute("class", "table table-striped table-bordered");
            tableplace.appendChild(table)

            var tr1 = document.createElement("tr");
            tr1.setAttribute("class", "cellHeader");
            var tr2 = document.createElement("tr");
            tr2.setAttribute("class", "cellHeader");
            var thead = document.createElement("thead");
            thead.appendChild(tr1);
            thead.appendChild(tr2);
            table.appendChild(thead);

            var _vue = this;


            let columnDefs = [];
            var len = this.columns.length;
            for (var i = 0; i < len; i++) {

                var el = {};

                var classname = '_dt-body-' + this.columns[i].alignInColumn;

                el = {
                    targets: i,
                    className: classname,

                    render: function (data, type, row, meta) {
                        if (data == null) {
                            data = "";
                        }

                        data = $.fn.dataTable.render.text().display(data);
                        if (data.display != undefined) {
                            data.display = $.fn.dataTable.render.text().display(data.display);
                        }

                        if (meta.col == 0) {
                            if (data == null) {
                                return "";
                            }
                            let variant = "warning";
                            if (_vue.appConf.status.isHDL == true) {
                                if (row.pinNumber_symbol == row.pinNumber_hdlsymbol && row.pinNumber_hdlsymbol == row.pinNumber_footprint && row.pinNumber_symbol == row.pinNumber_footprint) {
                                    variant = "success";

                                } else {
                                    _vue.pinNumberMatching = false;
                                }
                            } else {
                                if (row.pinNumber_symbol == row.pinNumber_footprint) {
                                    variant = "success";

                                } else {
                                    _vue.pinNumberMatching = false;
                                }
                            }

                            return "<b-badge class='badge badge-" + variant + " '>" + data + "</b-badge>";
                        }
                        if (_vue.appConf.status.isHDL == true) {
                            if (meta.col == 1) {
                                if (data == null) {
                                    return "";
                                }
                                let variant = "warning";
                                if (row.pinName_symbol == row.pinName_hdlsymbol) {
                                    variant = "success";

                                } else {
                                    _vue.pinNumberMatching = false;
                                }

                                return "<b-badge class='badge badge-" + variant + " '>" + data + "</b-badge>";
                            }
                        }
                        let four = 3;
                        let five = 4;
                        let seven = 6;
                        if (_vue.appConf.status.isHDL == false) {
                            four = 3;
                            five = 4;
                            seven = 5;
                        }

                        if (meta.col == four) {
                            if (data == null) {
                                return "";
                            }
                            let variant = "warning";
                            if (_vue.appConf.status.isHDL == true) {
                                if (row.pinNumber_symbol == row.pinNumber_hdlsymbol && row.pinNumber_hdlsymbol == row.pinNumber_footprint && row.pinNumber_symbol == row.pinNumber_footprint) {
                                    variant = "success";

                                } else {
                                    _vue.pinNumberMatching = false;
                                }
                            } else {
                                if (row.pinNumber_symbol == row.pinNumber_footprint) {
                                    variant = "success";

                                } else {
                                    _vue.pinNumberMatching = false;
                                }
                            }

                            return "<b-badge class='badge badge-" + variant + " '>" + data + "</b-badge>";
                        }

                        if (_vue.appConf.status.isHDL == true) {
                            if (meta.col == five) {
                                if (data == null) {
                                    return "";
                                }
                                let variant = "warning";
                                if (row.pinName_symbol == row.pinName_hdlsymbol) {
                                    variant = "success";

                                } else {
                                    _vue.pinNumberMatching = false;
                                }

                                return "<b-badge class='badge badge-" + variant + " '>" + data + "</b-badge>";
                            }
                        }
                        if (_vue.appConf.status.isHDL == true) {
                            if (meta.col == seven) {
                                if (data == null) {
                                    return "";
                                }
                                let variant = "warning";

                                if (row.pinNumber_symbol == row.pinNumber_hdlsymbol && row.pinNumber_hdlsymbol == row.pinNumber_footprint && row.pinNumber_symbol == row.pinNumber_footprint) {
                                    variant = "success";
                                    //_vue.pinNumberMatching = true;
                                } else {
                                    _vue.pinNumberMatching = false;
                                }

                                return "<b-badge class='badge badge-" + variant + " '>" + data + "</b-badge>";
                            }
                        }


                        return data;
                    }


                }

                columnDefs.push(el);
              
                
                var th2 = document.createElement("th");
             
                
                var br = document.createElement("br");
                th2.appendChild(br);
                tr2.appendChild(th2);

                
                var tx1 = document.createTextNode(i)
                
                
                var tx2 = document.createTextNode(this.columns[i].name)
                th2.appendChild(tx2);
                
                
                

            }

            let th1 = document.createElement("th");
            //tr1.appendChild(th1);
            let tx = document.createTextNode("")
            // th1.setAttribute("rowspan", 2);
            // th1.appendChild(tx);

            th1 = document.createElement("th");
            tr1.appendChild(th1);
            tx = document.createTextNode("Symbol")
            th1.appendChild(tx);
            th1.setAttribute("id", "symbolTH");
            th1.setAttribute("colspan", 3);

            if (_vue.appConf.status.isHDL == true) {
                th1 = document.createElement("th");
                tr1.appendChild(th1);
                tx = document.createTextNode("HDL symbol")
                th1.appendChild(tx);
                th1.setAttribute("id", "hdlsymbolTH");
                th1.setAttribute("colspan", 3);
            }
            

            th1 = document.createElement("th");
            tr1.appendChild(th1);
            tx = document.createTextNode("Footprint")
            th1.appendChild(tx);
            th1.setAttribute("id", "footprintTH");
            th1.setAttribute("colspan", 3);

            

            let symbolTH = document.getElementById("symbolTH");
            //symbolTH.setAttribute("colspan", 3);
            let footprintTH = document.getElementById("footprintTH");
            //footprintTH.setAttribute("colspan", 3);
            
            

            let no = 0;
            // if (this.libraryType == LibraryTypes.FOOTPRINT) {
            //     no = 1;
            // }

            var option = {};
            option.paging = true;
            option.info = true;
            option.dom = '<fr<t>ip>';
            option.data = this.items;
            option.myColumnFormats = this.columns;
            option.select = true;
            option.order = [[no, "asc"]];
            option.lengthMenu = [[10]];
            option.columns = this.colsAssign;

            option.columnDefs = columnDefs;
            option.initComplete = function () {

                
            }


            if ($.fn.dataTable.isDataTable("#t_" + this.id)) {
                this.mainTable.destroy();

            }

            var _vue = this;

            this.mainTable = $('#t_' + this.id).DataTable(option);

            this.mainTable.columns.adjust().draw();

            //hide first column in table

            // if (this.libraryType == LibraryTypes.FOOTPRINT) {
            //     this.mainTable.column(0).visible(false);
            // }

            let _mainTable = this.mainTable;


            // $('#t_' + this.id + " tbody").on('dblclick', 'tr', function () {


            //     let rowData = _mainTable.rows(this._DT_RowIndex).data();

            //     _vue.goTo(rowData[0]);



            // });


            //search input change view
            var searchplace = document.getElementById("t_" + this.id + "_filter").firstChild

            while (searchplace.firstChild) {

                if (searchplace.firstChild.textContent == "Search:") {
                    searchplace.removeChild(searchplace.firstChild);
                    break;
                }

            }
            searchplace.firstChild.setAttribute("placeholder", this.lang.placeholder_Search);
            searchplace.firstChild.setAttribute("class", "form-control form-control-sm")

            

        },

        
        
        

    }
}
</script>


<style lang="scss">
.PinAnalysisComponent {
    width: 100%;

    .dataTable {
        width: 100%;
    }

    table {
        font-size: 0.75rem;
        padding: 0px !important;

    }

    table th {
        padding: 2px !important;

    }

    table th select {
        width: 100% !important;

    }

    table td {
        padding: 0rem !important;

        padding-left: 0.2rem !important;
        padding-right: 0.2rem !important;

    }

    table.dataTable thead th {
        position: relative;
        background-image: none !important;
    }

    table.dataTable thead th p {
        margin-right: 20px;
    }

    .dataTables_processing {
        position: absolute;
        top: 20px;
        left: 50%;
        width: 100%;
        height: 20px;
        margin-left: -50%;
        margin-top: 50px;
        padding-top: 5px;
        text-align: center;
        font-size: 1em;

    }

    .dataTables_filter {
        font-size: 10px;
        float: left;
        width: 210px;
    }

    .searcher {
        float: left;
    }

    .dt-buttons {

        font-size: 0.7rem;
        margin-left: 210px;

    }

    .dataTables_filter .form-control-sm,
    .input-group-sm>.form-control {
        padding: 0.1rem 0.1rem;
        font-size: 0.7rem;
        line-height: 1;
        width: 200px;
    }

    .btn {
        padding-top: 1px;
        padding-bottom: 1px;
        padding-left: 3px;
        padding-right: 3px;

        font-size: 0.7rem;

    }

    .btn-group {
        display: block;
        padding-top: 2px;
    }

    ._dt-body-left {
        text-align: left;
    }

    ._dt-body-right {
        text-align: right;
    }

    ._dt-body-center {
        text-align: center;
    }

    .custom-select-sm {
        height: calc(1em + 0.5rem + 2px);
        padding-top: 0.0rem;
        font-size: 0.75rem;
    }

    select {
        margin-bottom: 5px;
        
    }
    .image-footprint{
      background-color: #ffffff;
      //border: 1px solid #dee2e6;
      border-radius: 0.25rem;
      margin-top: 3px;
      margin-bottom: 5px;
      margin-left: 2px;
      overflow: hidden;
      width: 200px;
      height: 200px;
      
    }
    .image-zoom {
    //   cursor: zoom-in;
    }
    svg{
      display: block;
      width: 200px;
      height: 200px;
      overflow: hidden;
      border: 1px solid #eee;
      border-radius: 0.25rem;
    }
    .bar-symbol{
      margin-top: 5px;
      margin-bottom: 5px;
      margin-left: 1px;
      width: 200px;
    }
    .input-viewer{
      width: 110px !important;
      
    }
    .btn-bar {
      height: 26.8px !important;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/shared/PinAnalysisComponent.vue